(function () {
  'use strict'

  var pluginName = "fixedPlayer";
  var defaults = {
    /* some default options */
  };

  // Plugin constructor
  function Plugin(element, options) {
    this.element = element;
    this.options = $.extend({}, defaults, options);
    this._defaults = defaults;
    this._name = pluginName;

    this.init();
  }

  // Plugin Methods
  Plugin.prototype = {
    init() {
      this.$element = $(this.element);
      this.$closeBtn = $('.js-close', this.element);
      this.$videoWrapper = $('.js-wrapper', this.element);
      this.$body = $('body');

      this.bindEvents();
    },

    playVideo() {
      var vimeoID = this.$element.data('vimeo');
      this.$videoWrapper.html('<iframe class="" src="https://player.vimeo.com/video/' + vimeoID + '?title=0&byline=0&portrait=0&autoplay=1&loop=0&api=0" width="100%" height="100%" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
    },

    closePlayer() {
      this.$element.addClass('is-hidden');
      this.$videoWrapper.html('');
      $('.js-reel-video').trigger('playVideo');
    },

    // EVENTS
    bindEvents() {
      this.$closeBtn.on('click', this.closePlayer.bind(this));
      this.$element.on('play', this.playVideo.bind(this));
    }
  };

  // Plugin wrapper
  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, "plugin_" + pluginName)) {
        $.data(this, "plugin_" + pluginName, new Plugin(this, options));
      }
    });
  }
}());
